import { useState, useEffect } from 'react'
import { JSON_FORM, SET_ENTIRE_STATE } from '#app/constants/forms.ts'
import { type BackendFormState } from '#types/form/wizard.ts'

type UseWizardFormTransitionStateReturn = {
	isTransitioning: boolean
	showPrevious: boolean
}

export function useWizardFormTransitionAndResetState<T>(
	data: BackendFormState<T>,
	isInJsonTree: any,
	currentQuestionId: any,
	currentStep: any,
	type: any,
	dispatch: any,
): UseWizardFormTransitionStateReturn {
	const [isTransitioning, setIsTransitioning] = useState(false)
	const [showPrevious, setShowPrevious] = useState(false)

	const isStepNonZero = currentStep !== 0
	const isInitialJsonTreeStep =
		currentStep === 0 && isInJsonTree && currentQuestionId !== 'A1'
	const isNonInitialJsonTreeStep = currentStep !== 0 && isInJsonTree

	useEffect(() => {
		setIsTransitioning(true)

		if (type === JSON_FORM) {
			setShowPrevious(
				(isStepNonZero && !isInJsonTree) ||
					isInitialJsonTreeStep ||
					isNonInitialJsonTreeStep ||
					false,
			)
		} else {
			setShowPrevious(currentStep > 0)
		}

		const timeout = setTimeout(() => setIsTransitioning(false), 200)
		return () => clearTimeout(timeout)
	}, [
		currentStep,
		isInJsonTree,
		currentQuestionId,
		type,
		isStepNonZero,
		isInitialJsonTreeStep,
		isNonInitialJsonTreeStep,
	])

	useEffect(() => {
		setIsTransitioning(false)

		if (data?.serverData) {
			dispatch({ type: SET_ENTIRE_STATE, payload: data.serverData })
		}
	}, [data, dispatch, setIsTransitioning])

	return { isTransitioning, showPrevious }
}
